import {resolvePolymorphVar} from "../../functions/generic";
import {ArrayUtils} from "../ArrayUtils";
import {ObjectUtils} from "../ObjectUtils";

/**
 * @deprecated - Use RefresherV2
 */
export class Refresher {
	constructor(callback, refreshTime = 10000, callbackOnConstruct = true, triggerOnConstruct = true) {
		this.refreshTime = refreshTime;
		this._callback = callback;
		this._timeout = null;
		this._stopped = false;

		if(callbackOnConstruct) {
			this._callback();
		}

		if(triggerOnConstruct) {
			this.trigger(refreshTime);
		}
	}

	trigger(params, refreshTime = this.refreshTime) {
		this._clearTimeout();

		//Hard stop, even if trigger is called, it should not create a timeout
		if(this._stopped) return;

		this._timeout = setTimeout(() => {
			this._callback(params);
		}, refreshTime);
	}

	forceTrigger(params) {
		this._clearTimeout();

		//Hard stop, even if trigger is called, it should not create a timeout
		if(this._stopped) return;

		this._callback(params);
	}

	stop() {
		this._stopped = true;
		this._clearTimeout();
	}

	reset() {
		this._stopped = false;
		this._callback();
	}

	_clearTimeout() {
		clearTimeout(this._timeout);
	}
}

export class RefresherV2 {
	constructor(
		callback,
		refreshTime = 10000,
		{
			callbackOnConstruct = true,
			triggerOnConstruct = true,
			failedAttemptsDelayCurve = {4: 5000, 10: 20000, 20: 60000, 25: 360000},
		} = {}
	) {
		this.callback = callback;
		this.refreshTime = refreshTime;
		this.failedAttemptsDelayCurve = failedAttemptsDelayCurve;

		this._retries = 0;

		if(callbackOnConstruct) {
			this.callback();
		}

		if(triggerOnConstruct) {
			this.trigger();
		}
	}

	get isStopped() {
		return this._stopped;
	}

	trigger(params, {refreshTime = this.refreshTime, applyErrorDelay = true} = {}) {
		this._clearTimeout();

		//Hard stop, even if the trigger is called, it should not create a timeout
		if(this._stopped) return;

		this._timeout = setTimeout(() => {
			this.callback(params);
		}, this._getRefreshTime(refreshTime, applyErrorDelay));
	}

	triggerFromError(params, {refreshTime = this.refreshTime, applyErrorDelay = true} = {}) {
		this.increaseRetryAmount();
		this.trigger(params, {refreshTime, applyErrorDelay});
	}

	forceTrigger(params) {
		this._clearTimeout();

		//Hard stop, even if trigger is called, it should not create a timeout
		if(this._stopped) return;

		this.callback(params);
	}

	triggerInactive(params, {refreshTime = this.refreshTime, applyErrorDelay = true} = {}) {
		if(this._timeout) return;

		this.trigger(params, {refreshTime, applyErrorDelay});
	}

	stop() {
		this._stopped = true;
		this._clearTimeout();
	}

	reset() {
		this._stopped = false;
	}

	increaseRetryAmount() {
		this._retries++;
	}

	setRetryAmount(amount) {
		this._retries = amount;
	}

	_clearTimeout() {
		clearTimeout(this._timeout);
	}

	_getRefreshTime(refreshTime = this.refreshTime, applyDelayCurve = true) {
		const resolvedTime = resolvePolymorphVar(
			refreshTime,
			{
				function: f => f(),
			},
			() => refreshTime,
			true
		);

		return resolvedTime + (applyDelayCurve ? (this._getDelayTime() || 0) : 0);
	}

	_getDelayTime(numberOfRetries = this._retries) {
		const curve = this.failedAttemptsDelayCurve;

		if(curve[numberOfRetries]) return curve[numberOfRetries];

		const curveRetriesAxis = ObjectUtils.map(curve,
			key => parseInt(key)
		).sort(
			(a, b) => a - b
		);

		return curve[
			RefresherV2.getActiveDelayTimePoint(curveRetriesAxis, numberOfRetries)
		] || 0;
	}

	static getActiveDelayTimePoint(retriesAmountAxis, attemptsAmount) {
		let prevAmount = -1;

		for(let i = 0; i < retriesAmountAxis.length; i++) {
			const retriesAmount = retriesAmountAxis[i];

			if(attemptsAmount < retriesAmount) return prevAmount;

			prevAmount = retriesAmount;
		}

		return ArrayUtils.lastItem(retriesAmountAxis);
	}
}
